import { useState, useEffect } from 'react';

export const useFetch = (url, params = {}) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        // Build URL with query parameters
        const urlWithParams = new URL(url);
        Object.keys(params).forEach((key) => {
          if (params[key] !== null && params[key] !== undefined) {
            urlWithParams.searchParams.append(key, params[key]);
          }
        });

        const response = await fetch(urlWithParams.toString());

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (error) {
        setError(error);
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };

    if (url) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, JSON.stringify(params)]); // Use JSON.stringify for deep comparison

  return { data, isLoading, error };
};
